import { intl } from '@beelday/common'
import styled from '@emotion/styled'
import {
	Card,
	CardLabel,
	CardText,
	CardTitle,
	CenteredHint,
	Eyebrow,
	Screen,
} from './primitives'

const TaskCard = styled(Card)`
	margin-bottom: 12px;
`

type Props = {
	name?: string
	description?: string
}

/**
 * Group work: the task, so each table can re-read it without turning to the
 * projector. No timer and no roster - `SimpleGrouping` carries neither a
 * duration nor who is in which group. A trainer may leave the task blank;
 * the card then says it will be explained in the room, rather than leaving
 * the screen all but empty.
 */
export const GroupWorkView = ({ name, description }: Props): JSX.Element => (
	<Screen data-testid="in_person.mobile.group_work">
		<Eyebrow>
			<intl.Translate>features.simple-grouping.title</intl.Translate>
		</Eyebrow>
		<TaskCard>
			<CardLabel>
				<intl.Translate>in_person.mobile.group_work.task</intl.Translate>
			</CardLabel>
			{name ? <CardTitle>{name}</CardTitle> : null}
			{description ? <CardText>{description}</CardText> : null}
			{name || description ? null : (
				<CardText>
					<intl.Translate>in_person.mobile.group_work.no_task</intl.Translate>
				</CardText>
			)}
		</TaskCard>
		<CenteredHint>
			<intl.Translate>in_person.mobile.group_work.hint</intl.Translate>
		</CenteredHint>
	</Screen>
)

export default GroupWorkView
